import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "step__fifth" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("label", { for: "title" }, "Список подписантов доверенности", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", null, "После добавления подписантов, сделайте активным того, от которого будет подаваться заявление", -1)
const _hoisted_4 = { class: "selected__signatures" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = ["value", "checked", "onClick"]
const _hoisted_7 = {
  key: 0,
  style: {"margin-top":"1rem"},
  for: "title"
}
const _hoisted_8 = {
  key: 1,
  style: {"margin-top":"1rem"},
  for: "title"
}
const _hoisted_9 = {
  key: 2,
  style: {"margin-top":"1rem"}
}
const _hoisted_10 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LogoutIcon = _resolveComponent("LogoutIcon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createElementVNode("div", _hoisted_4, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.document.signatory_list, (input, index) => {
        return (_openBlock(), _createElementBlock("div", { key: index }, [
          _createElementVNode("section", {
            onClick: ($event: any) => (_ctx.document.signatory_main = input.id),
            style: {"cursor":"pointer"}
          }, [
            _createElementVNode("input", {
              type: "radio",
              name: "signatory",
              style: {"cursor":"pointer"},
              value: input.id,
              checked: input.id == _ctx.document.signatory_main,
              onClick: ($event: any) => (_ctx.document.signatory_main = input.id)
            }, null, 8, _hoisted_6),
            _createElementVNode("p", null, _toDisplayString(input.name), 1)
          ], 8, _hoisted_5),
          _createVNode(_component_LogoutIcon, {
            style: {"cursor":"pointer"},
            onClick: ($event: any) => (_ctx.signatory_delete(index))
          }, null, 8, ["onClick"])
        ]))
      }), 128))
    ]),
    (_ctx.signatory_options_comp.length == 0)
      ? (_openBlock(), _createElementBlock("label", _hoisted_7, "Вы добавили всех подписантов – создайте новых"))
      : _createCommentVNode("", true),
    (_ctx.signatory_options_comp.length > 0)
      ? (_openBlock(), _createElementBlock("label", _hoisted_8, "Добавить подписантов из списка"))
      : _createCommentVNode("", true),
    (_ctx.signatory_options_comp.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
          (_ctx.signatory_options_comp.length > 0)
            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.signatory_options_comp, (input, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: index,
                  onClick: ($event: any) => (_ctx.signatory_add(input.id, input.name)),
                  style: {"cursor":"pointer"}
                }, _toDisplayString(input.name), 9, _hoisted_10))
              }), 128))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("button", {
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.new_sign && _ctx.new_sign(...args)))
    }, "Создать нового подписанта")
  ]))
}